import React, {useState} from "react";
import { t } from "../../../../../utils/i18n";

const SellerOtherPaymentMethodDetails = ({
  isSeller,
  instructionsFrom,
  sellerPaymentDetail,
  paymentMethod,
  transferTotal,
  referenceMessage,
  sellerUsername,
  buyerUsername,
  buyerName,
}) => {
  const [copied, setCopied] = useState(null);

  const handleCopy = (text, field) => {
      navigator.clipboard.writeText(text);
      setCopied(field);
      setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
  };

  return (
    <div>
      <p className="tradedetails-tradeinfo-title">
      <i className="fas fa-info-circle"></i>
      {" "}{isSeller ? t("p2p.details.my_payment") : t("p2p.details.sellers_payment")}
      </p>
      <div>
        <div>
          <div>
            <div>
              {!isSeller ? (
                <p
                  className="tradedetails-instructions-from"
                  dangerouslySetInnerHTML={{ __html: t("p2p.details.use_details_html") }}
                />
              ) : (
                <p
                  className="tradedetails-instructions-from"
                  dangerouslySetInnerHTML={{ __html: t("p2p.details.confirm_details_html") }}
                />
              )}
              <div className="bank_details">
                {sellerPaymentDetail && (
                  <div>
                    <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                      <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.payment_method")}</label> 
                      <span className="tradedetails-tradeinfo-payment-textvalues">{paymentMethod}
                        <button onClick={() => handleCopy(paymentMethod, "paymentmethod")} className="tradedetails-copybtn">
                          <i className={`fas fa-${copied === "paymentmethod" ? "check" : "copy"}`}  title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                        </button>
                      </span>
                    </div>
                    
                    <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                      <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.method_details", { method: paymentMethod })}</label>
                      <span className="tradedetails-tradeinfo-payment-textvalues">{sellerPaymentDetail}
                        <button onClick={() => handleCopy(sellerPaymentDetail, "sellerPaymentDetail")} className="tradedetails-copybtn">
                          <i className={`fas fa-${copied === "sellerPaymentDetail" ? "check" : "copy"}`}  title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                        </button>
                      </span>
                    </div>

                    <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                      <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.reference")}</label>
                      <span className="tradedetails-tradeinfo-payment-textvalues">{referenceMessage || "hands polish"}
                        <button onClick={() => handleCopy(referenceMessage || "hands polish", "referenceMessage")} className="tradedetails-copybtn">
                          <i className={`fas fa-${copied === "referenceMessage" ? "check" : "copy"}`}  title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                        </button>
                      </span>
                    </div>

                    <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                      <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.total")}</label> 
                      <span className="tradedetails-tradeinfo-payment-textvalues">{transferTotal}
                        <button onClick={() => handleCopy(transferTotal, "transferTotal")} className="tradedetails-copybtn">
                          <i className={`fas fa-${copied  === "transferTotal" ? "check" : "copy"}`}  title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                        </button>
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div>
                <p>{isSeller ? t("p2p.details.buyers_details") : t("p2p.details.sellers_details")}</p>
                <div>
                  <div>
                    <div>
                      <div className="trade_bank_account">
                        <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                          <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.common.name_colon")}</label> 
                          <span className="tradedetails-tradeinfo-payment-textvalues">{isSeller ? buyerName : sellerUsername}</span>
                        </div>
                        <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                          <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.total")}</label>
                          <span className="tradedetails-tradeinfo-payment-textvalues">{transferTotal}
                            <button onClick={() => handleCopy(transferTotal, "transferTotal")} className="tradedetails-copybtn">
                              <i className={`fas fa-${copied === "transferTotal" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                            </button>
                          </span>
                        </div>
                        <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames" title={t("p2p.details.ref_tip")}>{t("p2p.details.tx_ref")}</label>
                          <span className="tradedetails-tradeinfo-payment-textvalues">{referenceMessage || "hands polish"}
                            <button onClick={() => handleCopy(referenceMessage || "hands polish", "referenceMessage")} className="tradedetails-copybtn">
                              <i className={`fas fa-${copied === "referenceMessage" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerOtherPaymentMethodDetails;
